<template>
    <div class="pizza_info">
      <div class="left_text">
    <span class="size_item"></span>
    <h2 class="title_item">{{getbox_details.name}}</h2>
     <div class="allergi_item">
        <template v-for="allg in getbox_details.allergy">
            <img :src="allg.icon" :alt="allg.name" :key="allg.id">
        </template>
    </div>
     <p class="component_item">
        <template v-for="comp in getbox_details.components">
            <template v-for="comp_n in comp.data">
                <span v-show="comp_n.basic"
                    :class="[(comp_n.basic?'basic_comp':'') , ((comp_n.basic && comp.is_radio)?'':'okshow') ,`extra-${comp_n.id}` ,(comp.is_radio ? `radioshape_${comp.cat_id}`:``)] "
                    :key="comp_n.id">
                    {{comp_n.name}}
                </span>
            </template>
        </template>
    </p>
    <!-- <p style="color:black;margin-top:10px">{{iteminfoData}}</p> -->
</div>
    </div>
</template>
<script>
export default {
    name:'item_info_til',
    props:[ 'iteminfoData' , 'getbox_details'],
}
</script>
<style lang="scss">
 // start page custom
    .wrap_custom {

        // overflow-x: hidden;
        //   min-height: 100vh;
        .left_wrap {
            position: sticky;
            top: 50px;
            // display: flex;
            // align-items: center;
            color: black;
            display: inline-block;
        }

        
        .left_text {
            flex: 0 0 calc(100% - 200px);
            color: black;
            padding-right: 30px;
            padding-top: 70px;
        }

        // test size 
        .size_item {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 10px;
            display: block;
        }

        .title_item {
            font-size: 21px;
            font-weight: 700;
            margin-bottom: 10px;
             color: var(--active_color);
        }

        .component_item {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        .component_item span {
            display: none;
        }

        .component_item span.basic_comp {
            display: inline-block;
            margin-right: 6px;
        }

        .component_item span::after {
            content: ' - ';
        }

        .component_item span:last-child {
            content: '';
        }

        .allergi_item {
            img {
                width: 21px;
                height: 21px;
                object-fit: contain;
                margin-right: 10px;
                     filter: grayscale(300%) brightness(70%) sepia(100%) hue-rotate(8deg) saturate(500%) contrast(1);
            }
        }
    .extra_added::before {
        content: "Extra";
        font-weight: 700;
        color: var(--active_color);
    }

    }
</style>